import styles from './../_products.module.scss'
import classNames from 'classnames'
import { t } from '../../../../utils'
import Link from 'next/link'

const ProductsContent: React.FC<{ children?: React.ReactNode }> = ({
  children
}) => {
  return (
    <section className={classNames('section', styles.productsMainSection)}>
      <div className={classNames('container', styles.productsMainContainer)}>
        <div className="columns is-variable">
          <div
            className={classNames(
              'column is-12-tablet  is-5-desktop has-text-justified content',
              styles.productsContent
            )}
          >
            {children}
            <div className={styles.startButton}>
              <Link
                href="/store/songs"
                prefetch={false}
                className="button is-primary is-large is-rectangular"
              >
                {t('Get Started >>')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProductsContent
